var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('company-info', {
    attrs: {
      "detail": _vm.detail,
      "isNeedNomineeDirector": _vm.isNeedNomineeDirector
    }
  }), _c('shareholders-detail', {
    staticClass: "mt40",
    attrs: {
      "stepName": "companyName",
      "country": "Singapore",
      "applymentId": _vm.detail.id,
      "applymentStatus": _vm.detail.applymentStatus,
      "companyMemberList": _vm.detail.companyMemberList,
      "hasNomineeDirector": _vm.detail.hasNomineeDirector,
      "businessType": _vm.detail.businessType,
      "supplierList": _vm.detail.supplierList,
      "isNeedNomineeDirector": _vm.isNeedNomineeDirector
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }